import '@surf-turf/nemo/assets/extender-surf-details'